import type { ChainIdentifier } from "@opensea/graphql"
import { proxy } from "valtio"
import { deepClone } from "valtio/utils"

// -- Types ---------------------------------------------------------
export type TransactionIdentifier = {
  chain: ChainIdentifier
  hash: string
}

type CurrentTransactionStateType = {
  transaction?: TransactionIdentifier
}

// -- State ---------------------------------------------------------
const INITIAL_STATE: CurrentTransactionStateType = {
  transaction: undefined,
}

export const CurrentTransactionState = proxy<CurrentTransactionStateType>(
  deepClone(INITIAL_STATE),
)

// -- Actions -------------------------------------------------------
export const CurrentTransactionActions = {
  setTransaction(transaction?: TransactionIdentifier) {
    CurrentTransactionState.transaction = transaction
  },
}
